import React from 'react';
import DataTable from '../Components/DataTable';
import StatusBadge from '../Components/StatusBadge';

function TablaEmpresas({ onSelectionChange, loading, error, onRetry, emptyStateNoReload, pageSize, currentPage, onPageChange, ...props }) {
    const { empresas = [] } = props;

    const columns = [
        {
            Header: 'ID',
            accessor: 'IdEmpresa',
        },
        {
            Header: 'Nombre',
            accessor: 'Nombre',
        },
        {
            Header: 'Logo',
            accessor: 'Url_File',
            Cell: ({ value }) => (
                <img 
                    src={value || '/favicon.png'} 
                    alt="Logo" 
                    className="avatar"
                    style={{ width: '40px', height: '40px', objectFit: 'cover', borderRadius: '8px' }}
                    onError={(e) => {
                        e.target.src = '/favicon.png';
                    }}
                />
            )
        },
        {
            Header: 'Estado',
            accessor: 'IdEstado',
            Cell: ({ value }) => <StatusBadge status={value || 'Activa'} />
        },
        {
            Header: 'Promoción',
            accessor: 'Promocion',
            Cell: ({ value }) => (
                <div title={value} style={{ maxWidth: '200px' }}>
                    {value && value.length > 30 ? `${value.substring(0, 30)}...` : value}
                </div>
            )
        },
        {
            Header: 'Ubicación',
            accessor: 'Ubicacion',
            Cell: ({ value }) => (
                <div title={value} style={{ maxWidth: '200px' }}>
                    {value && value.length > 30 ? `${value.substring(0, 30)}...` : value}
                </div>
            )
        }
    ];

    return (
        <div id="tabla-empresas-container" className="tabla-empresas-wrapper">
            <DataTable
                id="tabla-empresas-datatable"
                data={empresas}
                columns={columns}
                idField="IdEmpresa"
                onSelectionChange={onSelectionChange}
                loading={loading}
                error={error}
                onRetry={onRetry}
                emptyStateNoReload={emptyStateNoReload}
                emptyMessage="Datos no encontrados"
                className="tabla-empresas"
                pageSize={pageSize}
                currentPage={currentPage}
                onPageChange={onPageChange}
            />
        </div>
    );
}

export default TablaEmpresas;
